import { render, staticRenderFns } from "./IndexPurchaseCreditTable.vue?vue&type=template&id=0450b7b8&"
import script from "./IndexPurchaseCreditTable.vue?vue&type=script&lang=js&"
export * from "./IndexPurchaseCreditTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports